export default class TweensIntro
{
    constructor(scene)
    {
        this.scene = scene;
    }

    //Intro
    BalloonsRise(Array,Array2)
    {
        var DelayNum;
        var RiseTween;
        this.scene.playSound("balloons_rising_title_tween");
        Array.forEach((child,num)=>
        {
            DelayNum = Math.floor(Math.random() * 100)+200;
            this.scene.addTween(child, 2000, {y: {start: 700, to: child.y}, delay: DelayNum},Phaser.Math.Easing.Quadratic.Out);
            if (num > 0)
            {
                //console.log(num);
                RiseTween = this.scene.addTween(Array2[num-1], 2000, {y: {start: Array2[num-1].y + 700, to: Array2[num-1].y}, delay: DelayNum},Phaser.Math.Easing.Quadratic.Out);
                if (num === 6)
                {
                    RiseTween.once('complete',()=>{this.BalloonsIdle(Array,Array2);});
                }
            }
        });
    }

    BalloonsIdle(Array,Array2)
    {
        var RandomTime;
        var RandomBalloonHeight;
        Array.forEach((child,num)=>
        {
            RandomTime = Math.floor(Math.random() * 500)+1100;
            RandomBalloonHeight = Math.floor(Math.random() * 10)+5;
            this.scene.addTween(child, RandomTime, {y: RandomBalloonHeight + child.y, yoyo:true, loop:-1},Phaser.Math.Easing.Quadratic.InOut);
            if (num > 0)
            {
                this.scene.addTween(Array2[num-1], 3000, {y: Array2[num-1].y + RandomBalloonHeight, yoyo:true, loop:-1},Phaser.Math.Easing.Quadratic.InOut);
            }
        });
    }

    FireRise(Array,Text, CakeArray,PlayBalloon)
    {
        var FireCall;
        this.scene.playSound('candles_title_tween');
        Array.forEach((child,num)=>
        {
            FireCall = this.scene.addTween(child, 1000, {scale:{start: 0, to:1}, alpha:.95, yoyo:false, delay: num *120}, Phaser.Math.Easing.Elastic.Out);
            if (num === 4)
            {
                FireCall.once('complete',()=>{
                    this.FireIdle(Array);
                    this.CakeText(Text, CakeArray,PlayBalloon)
                });
            }
        });
    }

    FireIdle(Array)
    {
        var RandomTimeFlame;
        Array.forEach((child)=>
        {
            RandomTimeFlame = Math.floor(Math.random() * 500)+500;
            this.scene.addTween(child, 400, {y: child.y + 3, yoyo:true, loop: -1, delay: RandomTimeFlame}, Phaser.Math.Easing.Quadratic.In);
        });
    }

    CakeLetters(Array, PlayBalloon)
    {
        var LetterTween;
        this.scene.playSound("cake");
        // TODO ADJUST TIMING OF THIS TWEEN FOR SPANISH
        Array.forEach((child,num)=>
        {
            LetterTween = this.scene.addTween(child, 300, {alpha:{start: 0, to: 1}, delay: 100 * num});
            if (num === 3)
            {
                LetterTween.once('start',()=>{this.PlayBalloonRise(PlayBalloon)});
            }

        });
    }

    CakeText(Text, CakeArray, PlayBalloon)
    {
        let MakeATextTween = this.scene.addTween(Text, 800, {alpha:{start: 0, to: 1}});
        MakeATextTween.once('start',()=>{
            this.scene.playSound("make-awav");
        });
        MakeATextTween.once('complete',()=>{
            this.CakeLetters(CakeArray,PlayBalloon);
        });
    }

    PlayBalloonRise(PlayBalloon)
    {
        //console.log(PlayBalloon);
        
        //console.log(this.scene.playSound("tween_up"));

        let PlayRise = this.scene.addTween(PlayBalloon[0], 1400, {y:{start: PlayBalloon[0].y + 800, to: PlayBalloon[0].y}},Phaser.Math.Easing.Quadratic.InOut);
        this.scene.addTween(PlayBalloon[1], 1400, {y:{start: PlayBalloon[1].y + 800, to: PlayBalloon[1].y}},Phaser.Math.Easing.Quadratic.InOut);

        PlayRise.once('start',()=>
        {
            this.scene.addDelay(750,()=>{
              this.scene.playSound("tween_up");
            });
            //console.log("start");
            PlayBalloon[0].setVisible(true);
            PlayBalloon[1].setVisible(true);
        });
        PlayRise.once('complete',()=>
        {
            PlayBalloon[2].setVisible(true);
            this.PlayBalloonIdle(PlayBalloon);
        });
    }

    PlayBalloonIdle(PlayBalloon)
    {
            let RandomTime = Math.floor(Math.random() * 500)+1100;
            let RandomBalloonHeight = Math.floor(Math.random() * 10)+5;
            PlayBalloon.forEach((child,num)=>
            {
                this.scene.addTween(child, RandomTime, {y: RandomBalloonHeight + child.y, yoyo:true, loop:-1},Phaser.Math.Easing.Quadratic.InOut);
            });
    }

    ToColorBalloons(Array, Array2,PlayButton)
    {
        this.scene.tweens.killTweensOf(PlayButton);
        this.scene.addTween(PlayButton, 1000, {y: PlayButton.y - 800},Phaser.Math.Easing.Quadratic.Out);
        Array.forEach((child,num)=>
        {
            this.scene.tweens.killTweensOf(child);
            this.scene.addTween(child, 1000, {y: child.y - 800},Phaser.Math.Easing.Quadratic.Out);
            if (num > 0)
            {
                this.scene.tweens.killTweensOf(Array2[num-1]);
                //console.log(num);
                this.scene.addTween(Array2[num-1], 1000, {y: Array2[num-1].y - 700},Phaser.Math.Easing.Quadratic.Out);
            }
        });
    }

    ToColorCake(Flame, Text, Letters, Cake,Table)
    {
        let CakeGroup = this.scene.add.group();
        CakeGroup.addMultiple([Text, Cake]);
        CakeGroup.addMultiple(Letters);
        CakeGroup.addMultiple(Flame);
        CakeGroup.getChildren().forEach((child)=>{
            this.scene.addTween(child, 600,{x: child.x - 800}, Phaser.Math.Easing.Quadratic.In);
        });
        this.scene.addDelay(610,()=>
        {
            let TableDrop = this.scene.addTween(Table, 300, {y: Table.y + 84}, Phaser.Math.Easing.Quadratic.InOut);
            TableDrop.once('complete',()=>{
                this.scene.scene.start("PickCakeColor");
            });
        });
    }
}